(function ($, Global) {
    var urlParams = new UrlParams();
    function TransactionCommandComponent() {
        // Déclaration class objet
    }

	TransactionCommandComponent.prototype.initEvents = function () {
		this.publishers();
	}

	TransactionCommandComponent.prototype.publishers = function () {
        $(document).ready(function () {
            var params = urlParams.getParams();
            var action = $('.transaction-command [name="Readers"]').attr('data-action');
            var $tips = $('.tip');

            if ($tips.find('input, select').val()) {
                $tips.removeClass('in');
            }

            if (params.readers && params.readers == '100') {
                nbReadersTooMuch();
            }

			$.Topic('update-simulator').publish(action);
		});

		$(document).on('submit', '.transaction-command form', function (e) {
			e.preventDefault();
		});			

		$(document).on('change', '.transaction-command [name="Readers"], .transaction-command [name="Currency"]', function () {
			var action = $(this).attr('data-action');

			$.Topic('update-simulator').publish(action);
		});

		$(document).on('change blur', '.transaction-command [name="Readers"], .transaction-command [name="Currency"]', function () {
            var $this = $(this);
            var $tip = $this.closest('.tip');

            if ($this.val() == null) {
                $tip.addClass('in');
            } else {
                $tip.removeClass('in');
            }
		});

		$(document).on('focus', '.transaction-command [name="Readers"], .transaction-command [name="Currency"]', function () {
            var $this = $(this);
            $this.closest('.tip').removeClass('in');
		});	

		$(document).on('change', '.transaction-command [name="Readers"]', function () {
			var nbPersons = $(this).val();
			var $message = $('.transaction-command .message');

			if (nbPersons > 20) {
			    nbReadersTooMuch();
			} else {
				$message.removeClass('show');
				$message.parent().find('label, select').show();
				$('.transaction-command .btn:first').show();
			}
        });
    }

    function nbReadersTooMuch() {
        var $message = $('.transaction-command .message');
        $message.addClass('show');
        $message.parent().find('label, select').hide();
        $('.transaction-command .btn:first').hide();
    }

	Global.TransactionCommandComponent = TransactionCommandComponent;
}(jQuery, window));